var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Paginate paginate-warp w-full py-4"},[_c('sliding-pagination',{staticClass:"hidden md:block",attrs:{"current":_vm.pagination.currentPage,"total":_vm.pagination.length},on:{"page-change":_vm.pageChangeHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }